const myStoredValue = []
const storedValueCardDefinitionList = []

export default {
  myStoredValue,
  storedValueCardDefinitionList
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-stored-value/store/state.js